<template>
	<div class="finance-product">
		<div class="section-label">金融产品</div>
		<OptionBox
			class="product-types"
			:options="financesList"
			:value="activeCategory"
			value-key="finance_category"
			nowrap
			:columns="financesList.length < 3 ? financesList.length : 3"
			@change="selectTypeByCategory"
		>
			<template slot-scope="{ option }">
				<div class="product-name">{{ option.finance_name }}</div>
				<nio-tag
					v-if="option.finance_type === 'DISCOUNT'"
					class="discount-tag"
					type="shown"
					size="small"
					text="优惠"
					base-color="var(--bg_success_weak_default, #f2feff)"
					text-color="var(--text_success_default, #00bebe)"
				/>
				<span v-else class="product-description">{{ option.synopsis }}</span>
			</template>
		</OptionBox>
		<div v-if="!financesList.length" class="plan-status">该城市暂无金融方案</div>
		<div class="product-list">
			<nio-cell
				v-for="product in visibleProducts"
				:key="product.product_code"
				class="product-item"
				:title="product.name"
				:description="product.synopsis"
				:padding-vertical="10"
				clickable
				@click="selectProduct(product)"
			>
				<template #right>
					<nio-radio
						:value="selectedProductCode"
						:label="product.product_code"
						size="medium"
						@input="selectProduct(product)"
					/>
				</template>
			</nio-cell>
		</div>
	</div>
</template>

<script>
import { NioCell, NioTag } from '@nio-fe/nio-app-ui'
import OptionBox from '@/components/OptionBox.vue'

export default {
	name: 'FinanceProductType',
	components: { NioCell, NioTag, OptionBox },
	props: {
		financesList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			activeIndex: 0,
			selectedProductCode: null
		}
	},
	computed: {
		activeCategory() {
			const category = this.financesList[this.activeIndex]
			return category ? category.finance_category : null
		},
		visibleProducts() {
			const category = this.financesList[this.activeIndex]
			return category && Array.isArray(category.production_infos) ? category.production_infos : []
		}
	},
	watch: {
		financesList: {
			immediate: true,
			handler() {
				this.activeIndex = 0
				const product = this.visibleProducts[0]
				this.selectedProductCode = product ? product.product_code : null
			}
		}
	},
	methods: {
		selectTypeByCategory(category, selected) {
			const index = this.financesList.indexOf(selected)
			if (index !== -1) this.selectType(index)
		},
		selectType(index) {
			if (this.activeIndex === index) return
			this.activeIndex = index
			const product = this.visibleProducts[0] || null
			this.selectedProductCode = product ? product.product_code : null
			this.emitChange(product)
		},
		selectProduct(product) {
			if (this.selectedProductCode === product.product_code) return
			this.selectedProductCode = product.product_code
			this.emitChange(product)
		},
		emitChange(product) {
			const category = this.financesList[this.activeIndex]
			this.$emit('change', {
				productType: category ? category.finance_category : null,
				product
			})
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';
.finance-product {
	margin-right: 0 !important;
}

.section-label {
	display: flex;
	align-items: flex-end;
	min-height: 25px;
	margin-bottom: 10px;
	color: $text_secondary;
	@include body_3(1.5, 400, false);
}

.product-types {
	width: 100%;
	padding-right: 10px;
}

::v-deep .option-box__item {
	height: 60px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	@include body_2(1.5, 400, false);
}

.product-name,
.product-description {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.product-description {
	color: #999dae;
	@include body_3(1.5, 400, false);
}

.discount-tag {
	height: 18px;
	padding: 0 5px;
	border: 0;
	border-radius: 1px;
	@include body_3(1.5, 400, false);
}

.product-list {
	margin-top: 10px;
	margin-right: 20px;
}

.plan-status {
	margin: 10px 20px 0 0;
	padding: 20px 0;
	color: $text_secondary;
	border: 1px solid var(--border_divider_primary, #ebecee);
	text-align: center;
	@include body_3(1.5, 400, false);
}

.product-item {
	padding-right: 0 !important;
	padding-left: 0 !important;
	min-height: 61px;
	box-sizing: border-box;
}

::v-deep {
	.nio-cell__left {
		flex: 1;
		min-width: 0;
	}

	.product-list {
		.nio-cell__right {
			flex: 0 !important;
			min-width: 0;
		}
	}

	.nio-cell__left-text {
		@include body_2(1.5, 400, false);
	}

	.nio-cell__left-description {
		margin-top: 2px;
		color: $text_tertiary;
		@include body_3(1.5, 400, false);
	}

	.product-item .nio-cell__right {
		flex-shrink: 0;
	}

	.nio-radio {
		margin: 0;
	}
}
</style>
